"use client";
import { useEffect, useRef, useState } from "react";
import ChevronDown from "@/components/icons/chevron-down";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const VideoDetail = ({ lead }: { lead: string }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollHeight > textRef.current.clientHeight,
      );
    }
  }, []);

  return (
    <div className="bg-brand-blue-100 rounded-2xl p-3 text-base leading-5 font-medium flex flex-col items-start gap-2">
      <span
        className={cn("w-full", {
          "line-clamp-2": !expanded,
        })}
        ref={textRef}
      >
        {lead}
      </span>
      {/* Sadece metin taşıyorsa veya zaten genişletilmişse butonu göster */}
      {(isOverflowing || expanded) && (
        <Button
          aria-expanded={expanded}
          className="text-brand-blue-600 px-2 py-1 -ml-2 h-auto self-end text-xs leading-4.5 font-semibold"
          onClick={() => setExpanded((prev) => !prev)}
          variant="ghost"
        >
          {expanded ? "Daha Az" : "Daha Fazla"}
          <ChevronDown
            className={cn(
              "stroke-brand-blue-600 fill-none transition-transform duration-200",
              {
                "rotate-180": expanded,
              },
            )}
          />
        </Button>
      )}
    </div>
  );
};

export default VideoDetail;
